import { createReducer } from '@reduxjs/toolkit';
import { dateToIsoString, isoStringToAmerican } from '@shared/lib/datetime';
import { deepFreeze } from '@shared/lib/deepFreeze';
import { formatValueWithPrefix } from '@shared/lib/format';
import * as dateFns from 'date-fns';
import { setBirthday, setCurrentStep } from '../actions/stepBirthdayActions';

export const selectCurrentStep = (state) => state.currentStep;
export const selectBirthday = (state) => state.birthday;
export const selectOptions = (state) => state.options;

export const selectLabel = (state, config) => {
  return config.label;
};

export const selectMessage = (state, config, data) => {
  if (data?.skipped === true) {
    return `Skipped: "${config.label}"`;
  }

  let birthday = '';
  if (data?.value !== undefined) {
    birthday = isoStringToAmerican(data.value);
  }

  return formatValueWithPrefix(config.valuePrefixLabel, birthday);
};

const initialState = deepFreeze({
  currentStep: 'picker',
  birthday: dateToIsoString(dateFns.subYears(new Date(), 28)),
  modified: false,
});

export const init = (args) => ({
  ...initialState,
  birthday: args.data?.value ?? initialState.birthday,
  currentStep: 'picker',
  modified: args.data?.value !== undefined,
});

export const stepBirthdayReducer = createReducer(initialState, {
  [setCurrentStep]: (state, action) => ({
    ...state,
    currentStep: action.payload,
  }),
  [setBirthday]: (state, action) => ({
    ...state,
    birthday: action.payload,
    modified: true,
  }),
});
